import type { IconSvgObject } from './types';

const UserCircle02Icon: IconSvgObject = [
  ["circle", { cx: "12", cy: "8.83984", r: "2.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16.7715 20.5C17.7295 17.3599 15.5598 14.1298 12.4156 14.0153L11.996 14L11.5844 14.015C8.44018 14.1297 6.27053 17.3598 7.22847 20.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default UserCircle02Icon;
